import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IWalletAmountReturn,
  IWalletAmountReturnInitialState,
} from "./walletamountreturnModel";
import {
  createWalletReturn,
  getAllWalletReturns,
  getWalletDetailFromMobileNo,
} from "./services/walletamountreturn.services";
import moment from "moment";

const initialState: IWalletAmountReturnInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  WalletAmountReturnList: [],
  WalletAmountReturnID: null,
  WalletAmountReturnDetail: {
    ID: null,
    ReturnDate: moment().toDate(),
    Amount: null,
    ReturnBalanceType: "",
    EntryType: "Return",
    UserID: null,
    Remarks: "",
  },
  FilterWalletAmountReturn: {
    ReturnDate: "",
    UserName: "",
    MobileNo: "",
    Amount: "",
    ReturnBalanceType: "",
    EntryType: "",
  },
};

const walletamountreturnSlice = createSlice({
  name: "walletamountreturn",
  initialState,
  reducers: {
    clearWalletAmountReturnDetails: (state) => {
      state.WalletAmountReturnDetail = initialState.WalletAmountReturnDetail;
    },
    setWalletAmountReturnID: (state, action) => {
      state.WalletAmountReturnID = action.payload;
    },
    clearWalletAmountReturnID: (state) => {
      state.WalletAmountReturnID = initialState.WalletAmountReturnID;
    },
    setFilterWalletAmountReturn: (state, action) => {
      state.FilterWalletAmountReturn = action.payload;
    },
    clearFilterWalletAmountReturn: (state) => {
      state.FilterWalletAmountReturn = initialState.FilterWalletAmountReturn;
    },
  },
  extraReducers: (builder) => {
    /* For getAll WalletReturns */
    builder.addCase(getAllWalletReturns.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWalletReturns.fulfilled,
      (state, action: PayloadAction<IWalletAmountReturn[]>) => {
        state.loading = false;
        state.WalletAmountReturnList = action.payload || [];
      }
    );
    builder.addCase(getAllWalletReturns.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WalletAmountReturnList = [];
    });

    /* For create WalletReturn */
    builder.addCase(createWalletReturn.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createWalletReturn.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createWalletReturn.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* get Wallet Details */
    builder.addCase(getWalletDetailFromMobileNo.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getWalletDetailFromMobileNo.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(getWalletDetailFromMobileNo.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearWalletAmountReturnID,
  clearWalletAmountReturnDetails,
  setWalletAmountReturnID,
  clearFilterWalletAmountReturn,
  setFilterWalletAmountReturn,
} = walletamountreturnSlice.actions;
export default walletamountreturnSlice.reducer;
